export default "__VITE_ASSET__D4aopu2x__"